<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Traslados" key="1">
        <g-master name="gesiton"
                  :endpoint="traslados.endpoint"
                  :tableSetup="traslados.tableSetup"
                  @action="trasladosAction"
                  ref="trasladosMaster"
                  :modalFieldsSetup="traslados.modalFieldsSetup">
          <template slot="expandedRowRender" slot-scope="{text}">
            <a-row style="max-width: 800px">
              <a-col :span="12" v-for="ve in traslados.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </a-col>
            </a-row>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
            <a-tag :color="text==='PENDIENTE' ? 'purple' : (text === 'APROBADO' ? 'green' : 'red')">{{text}}</a-tag>
          </span>

          <template slot="masterModal" slot-scope="{record}">
            <g-lookup label="Empleado"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                      :selectedObj.sync="trasladosModal.empleadoSeleccionado"
                      ref="empDropDown">
            </g-lookup>

            <g-dropdown endpoint="hierarchy_lookup"
                        label="Motivo Traslado"
                        :formItemConfig="fiOptions"
                        :decorator="['reason_transfer', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="trasladosModal.requestData.motivo_traslado"
                        :selectedObj.sync="trasladosModal.motivoTrasladoSeleccionado"></g-dropdown>

            <g-dropdown label="Tipo de Cargo"
                        v-show="trasladosModal.rules.tipo_cargo"
                        :formItemConfig="fiOptions"
                        endpoint="hierarchy_lookup"
                        :decorator="['id_h_type_job', { rules: [{ required: trasladosModal.rules.tipo_cargo, message: 'Valor requerido' }]}]"
                        :params="trasladosModal.requestData.tipo_cargo">
            </g-dropdown>

            <a-form-item v-bind="fiChkOptions" :has-feedback="false" label="">
              <a-checkbox v-decorator="['change_job', {valuePropName: 'checked'}]">
                Cambia de Cargo
              </a-checkbox>
            </a-form-item>

            <g-dropdown endpoint="jobs"
                        v-show="trasladosModal.rules.new_job"
                        label="Nuevo Cargo"
                        :formItemConfig="fiOptions"
                        :decorator="['new_job', { rules: [{ required: trasladosModal.rules.new_job, message: 'Valor requerido' }] }]"></g-dropdown>

            <a-form-item v-bind="fiChkOptions" :has-feedback="false" label="">
              <a-checkbox v-decorator="['change_boss', {valuePropName: 'checked'}]">
                Cambia Jefe
              </a-checkbox>
            </a-form-item>

            <g-lookup label="Jefe Nuevo"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      v-show="trasladosModal.rules.new_boss"
                      :decorator="['new_boss', { rules: [{ required: trasladosModal.rules.new_boss, message: 'Valor requerido' }] }]"
                      :selectedObj.sync="trasladosModal.jefenuevoseleccionado"
                      ref="jefeEmpDropDown"></g-lookup>
            <a-form-item label="Nueva Operación"
                         v-bind="fiOptions">
              <a-input id="new_operation" v-decorator="['new_operation']"></a-input>
            </a-form-item>
            <a-form-item v-bind="fiOptions" label="Observaciones">
              <a-textarea
                autoSize
                v-decorator="['observation', { trigger: 'change', rules: [{ required: true, message: 'Valor requerido' }]}]">
              </a-textarea>
            </a-form-item>
            <g-lookup label="Empleado Anterior"
                      :formItemConfig="fiOptions"
                      endpoint="empleados"
                      v-show="trasladosModal.rules.id_emp_replace"
                      :decorator="['id_emp_replace', { rules: [{ required: trasladosModal.rules.id_emp_replace, message: 'Valor requerido' }] }]"
                      :selectedObj.sync="trasladosModal.empanteriorseleccionado"
                      ref="empAntDropDown"></g-lookup>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <a-tabs defaultActiveKey="1" v-if="showAprobacion">
      <a-tab-pane tab="Aprobación" key="1">
        <a-spin :spinning="loading">
          <a-form :form="form" @submit="actualizarTrasladoSubmit" v-on:keyup.enter="actualizarTrasladoSubmit">
            <a-row v-show="!traslados.registroSeleccionado.id_emp_transfer">
              Seleccione un registro
              <a-icon type="search"></a-icon>
              para visualizar los detalles de aprobación.
            </a-row>
            <a-row :gutter="[16,16]" v-show="traslados.registroSeleccionado.id_emp_transfer">
              <a-col :md="8" :sm="24">
                <g-dropdown endpoint="hierarchy_lookup"
                            label="Tipo de Traslado"
                            :formItemConfig="fiOptions"
                            :decorator="['type_transfer', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                            :params="trasladosModal.requestData.tipo_traslado"></g-dropdown>
              </a-col>
              <a-col :md="8" :sm="24">
                <g-dropdown label="Unidad"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup_domains"
                            :decorator="['id_h_org1', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                            :params="trasladosModal.requestData.unidad">
                </g-dropdown>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item v-bind="fiChkOptions" :has-feedback="false" label="">
                  <a-checkbox v-decorator="['approved', {valuePropName: 'checked'}]">
                    Aprobado
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="[16,16]" v-show="traslados.registroSeleccionado.id_emp_transfer">
              <a-col :md="8" :sm="24">
                <a-form-item v-bind="fiOptions" label="Observaciones">
                  <a-textarea
                    autoSize
                    v-decorator="['approved_observation', { trigger: 'change', rules: [{ required: true, message: 'Valor requerido' }]}]">
                  </a-textarea>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <g-dropdown label="Línea"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup_domains"
                            :decorator="['id_h_org2', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                            :params="trasladosModal.requestData.linea">
                </g-dropdown>
              </a-col>
              <a-col :md="8" :sm="24" v-show="trasladosModal.rules.approved_date">
                <a-form-item v-bind="fiOptions" label="Fecha Aprobación">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['approved_date', { rules: [{ required: trasladosModal.rules.approved_date, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="[16,16]" v-show="traslados.registroSeleccionado.id_emp_transfer">
              <a-col :md="8" :sm="24">
                <a-form-item v-bind="fiChkOptions" :has-feedback="false" label="">
                  <a-checkbox v-decorator="['fit_salary', {valuePropName: 'checked'}]">
                    Ajuste Salario
                  </a-checkbox>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <g-dropdown label="Operación"
                            :formItemConfig="fiOptions"
                            endpoint="hierarchy_lookup_domains"
                            :decorator="['id_h_org3', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                            :params="trasladosModal.requestData.operacion">
                </g-dropdown>
              </a-col>

              <a-col :span="8" style="text-align: right;">
                <a-button type="primary" html-type="submit">Guardar</a-button>
              </a-col>
            </a-row>
            <a-row :gutter="[16,16]" v-show="traslados.registroSeleccionado.id_emp_transfer">

            </a-row>
          </a-form>
        </a-spin>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        loading: false,
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        fiChkOptions: {
          'wrapper-col': {
            offset: 8,
            span: 16
          }
        },
        traslados: {
          endpoint: 'gestion_humana/traslados',
          tableSetup: {
            columns: [
              {title: 'Solicitud', dataIndex: 'id_emp_transfer', sorter: true},
              {title: 'Aprobado', dataIndex: 'aprobado', sorter: true, scopedSlots: {customRender: 'estadoRenderer'}},
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Fecha Solicitud', dataIndex: 'fecha_solicitud', sorter: true},
              {title: 'Motivo de Traslado', dataIndex: 'motivo_tralado', sorter: true},
              {title: 'Fecha Aprobación', dataIndex: 'fecha_aprobacion', sorter: true}
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              scopedSlots: {customRender: 'hooverableAction'},
              width: 90,
              fixed: 'right',
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {icon: 'edit', type: 'link', style: 'height: 20px; width: 20px;'},
                  fnVisible: (record) => {
                    return !record.approved
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {icon: 'delete', type: 'link', style: 'height: 20px; width: 20px;'},
                  fnVisible: (record) => {
                    return !record.approved
                  }
                },
                {
                  name: 'detalles',
                  text: 'Detalles',
                  permisos: [],
                  props: {icon: 'search', type: 'link', style: 'height: 20px; width: 20px;'},
                  fnVisible: (record) => {
                    return this.showAprobacion
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_emp_transfer'
            },
            customSlots: ['estadoRenderer', 'customAction', 'progresoSlot', 'expandedRowRender']
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'change_job'},
            {name: 'new_job'},
            {name: 'change_boss'},
            {name: 'new_boss'},
            {name: 'new_operation'},
            {name: 'observation'},
            {name: 'reason_transfer'},
            {name: 'id_emp_replace'},
            {name: 'id_h_type_job'}
          ],
          valoresExpandidos: [
            {label: 'Unidad de Negocio', column: 'unidad'},
            {label: 'Linea', column: 'linea'},
            {label: 'Operacion', column: 'operacion'},
            {label: 'Jefe Actual', column: 'jefe_actual'},
            {label: 'Fecha Solicitud', column: 'fecha_solicitud'},
            {label: 'Cambia Cargo', column: 'change_job'},
            {label: 'Nuevo Cargo', column: 'nombre_cargo'},
            {label: 'Cambio Jefe', column: 'change_boss'},
            {label: 'Jefe Nuevo', column: 'new_boss'},
            {label: 'Nombre', column: 'jefe_nuevo'},
            {label: 'Nueva Operación', column: 'new_operation'},
            {label: 'Observación', column: 'observation'},
            {label: 'Motivo Traslado', column: 'reason_transfer'},
            {label: 'Empleado Anterior', column: 'id_emp_replace'},
            {label: 'Nombre', column: 'empleado_reemplaza'}
          ],
          registroSeleccionado: {}
        },
        trasladosModal: {
          empleadoSeleccionado: {},
          jefenuevoseleccionado: {},
          empanteriorseleccionado: {},
          motivoTrasladoSeleccionado: {},
          requestData: {
            proceso: {h_lookup_type: 'PERSON_REQUEST'}, // PROCESOS_PAZYSALVO
            motivo_traslado: {h_lookup_type: 'MOTIVO_TRASLADO', use_code: true}, // PROCESOS_PAZYSALVO
            tipo_traslado: {h_lookup_type: 'TIPO_TRASLADO', use_code: true},
            unidad: {h_lookup_domain: 'UEAN'},
            operacion: {h_lookup_domain: 'OPER'},
            linea: {h_lookup_domain: 'LINEA'},
            tipo_cargo: {h_lookup_type: 'CLASIFICACION_CARGO'}
          },
          rules: {
            new_job: false,
            new_boss: false,
            id_emp_replace: false,
            approved_date: false,
            tipo_cargo: false
          }
        },
        form: this.$form.createForm(this, {
          name: 'actualizarTraslado',
          onFieldsChange: (_, changedFields) => {
            this.formChanged(changedFields)
          }
        })
      }
    },
    mounted () {
      this.form.getFieldDecorator('type_transfer')
      this.form.getFieldDecorator('id_h_org1')
      this.form.getFieldDecorator('id_h_org2')
      this.form.getFieldDecorator('id_h_org3')
      this.form.getFieldDecorator('fit_salary')
      this.form.getFieldDecorator('approved')
      this.form.getFieldDecorator('approved_date')
      this.form.getFieldDecorator('approved_observation')
      this.httpClient = new HttpUtil('')
    },
    methods: {
      trasladosAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields.reason_transfer)) {
              this.$refs.trasladosMaster.modal.form.setFieldsValue({
                change_boss: false,
                change_job: false
              })
              this.trasladosModal.rules.new_boss = false
              this.trasladosModal.rules.new_job = false
              this.trasladosModal.rules.tipo_cargo = false

              switch (action.changedFields.reason_transfer.value) {
                case 'CJF':
                  this.$refs.trasladosMaster.modal.form.setFieldsValue({
                    change_boss: true
                  })
                  this.trasladosModal.rules.new_boss = true
                  break
                case 'CNU':
                  this.$refs.trasladosMaster.modal.form.setFieldsValue({
                    change_job: true
                  })
                  this.trasladosModal.rules.new_job = true
                  break
                case 'REM':
                  this.trasladosModal.rules.id_emp_replace = true
                  break
                case 'CPR':
                  this.trasladosModal.rules.tipo_cargo = true
                  break
              }
            }

            if (!JsUtils.isEmpty(action.changedFields.change_job)) {
              this.trasladosModal.rules.new_job = action.changedFields.change_job.value
            }

            if (!JsUtils.isEmpty(action.changedFields.change_boss)) {
              this.trasladosModal.rules.new_boss = action.changedFields.change_boss.value
            }
            break
          case 'masterCreate':
            this.trasladosModal.empleadoSeleccionado = {}
            this.trasladosModal.jefenuevoseleccionado = {}
            this.trasladosModal.empanteriorseleccionado = {}
            break
          case 'masterEdit':
            if (action.record.id_emp) {
              this.$refs.empDropDown && this.$refs.empDropDown.handleSearch(action.record.id_emp)
            }
            if (action.record.new_boss) {
              this.$refs.jefeEmpDropDown && this.$refs.jefeEmpDropDown.handleSearch(action.record.new_boss)
            }
            if (action.record.id_emp_replace) {
              this.$refs.empAntDropDown && this.$refs.empAntDropDown.handleSearch(action.record.id_emp_replace)
            }
            break
          case 'detalles':
            this.traslados.registroSeleccionado = action.record
            this.$refs.trasladosMaster.modal.form.setFieldsValue({cambia_cargo: action.record.change_job === 'S'})
            this.form.setFieldsValue({
              type_transfer: action.record.type_transfer,
              id_h_org1: action.record.id_h_org1,
              id_h_org2: action.record.id_h_org2,
              id_h_org3: action.record.id_h_org3,
              fit_salary: action.record.fit_salary,
              approved: action.record.approved,
              approved_date: action.record.approved_date ? moment(action.record.approved_date) : null,
              approved_observation: action.record.approved_observation
            })
            break
        }
      },
      formChanged (changedFields) {
        if (!JsUtils.isEmpty(changedFields.approved)) {
          this.trasladosModal.rules.approved_date = changedFields.approved.value
        }
      },
      actualizarTrasladoSubmit (e) {
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            this.loading = true
            values.id_emp_transfer = this.traslados.registroSeleccionado.id_emp_transfer
            values.approved_date = DateUtils.forBackEnd(values.approved_date)

            this.httpClient.getInstance().post('gestion_humana/traslados/update', {
              ...values
            })
              .then(response => {
                Mensajes.success('Correcto', 'Información actualizada correctamente.')
                this.refreshTable()
              })
              .catch(error => {
                Mensajes.error('Error', 'No fue posible actualizar el traslado.')
              })
              .then(() => {
                this.loading = false
              })
          }
        })
      },
      refreshTable () {
        this.$refs.trasladosMaster.$refs.datatable.loadData()
      }
    },
    computed: {
      showAprobacion () {
        return this.$userIsInrol('Management') || this.$userIsInrol('HRReq')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Traslados/Traslados.vue